module.exports = __webpack_public_path__ + "static/media/Presentation.939e9ce0.mp4";